import React, { useContext, useState } from 'react'
import { toast } from 'react-toastify'
import { Formik, Form } from 'formik'
import { FiDownload, FiUpload } from 'react-icons/fi'

import { Container } from './styles'
import Card from '../../../../components/Card'
import { api, authHeaders } from '../../../../services/api'
import { Button, File } from '../../../../components/Form'
import modeloCarga from '../../../../assets/modelo carga.xlsx'
import Modal from '../../../../components/Modal'
import Table from '../../../../components/Table'
import { GlobalContext } from '../../../../contexts/GlobalContext'

export default function () {
	const { checkException } = useContext(GlobalContext)

	const [relatorioCargaPessoas, setRelatorioCargaPessoas] = useState(null)

	async function handleCarregarPessoas(values, { reset }) {
		try {
			const response = await api.post(`/talento/carga/${values.arquivo}`, {}, authHeaders())

			const { errors, participantes_criados, participantes_vinculados } = response

			const pessoasIncluidasQuantidade = participantes_criados + participantes_vinculados

			const { sem_nome, cpf_invalido, grau_incorreto, formacao_incorreta } = errors

			setRelatorioCargaPessoas({
				pessoas_vinculadas: pessoasIncluidasQuantidade,
				pessoas_criadas: participantes_criados,
				cpf_invalido,
				grau_incorreto,
				formacao_incorreta,
				sem_nome
			})

			toast.success('Arquivo carregado!')

			reset()
		} catch (e) {
			checkException(e)
		}
	}

	return (
		<>
			<Container>
				<Card>
					<h1>Carga de talentos</h1>

					<div className="flex flex-col gap-3 mt-4 mx-2 mb-6">
						<p>Baixe a seguir a planilha modelo e preencha-a com as colunas solicitadas. Em seguida, faça o upload abaixo para carregar.</p>

						<a href={modeloCarga} target="_blank" className="flex items-center gap-2 w-fit bg-white rounded-md shadow-lg py-2 px-3 text-slate-700 hover:text-black hover:opacity-80 self-center">
							Baixar modelo
							<FiDownload size={16} />
						</a>
					</div>

					<Formik
						onSubmit={handleCarregarPessoas}
						initialValues={{
							arquivo: null
						}}
					>
						{({ setFieldValue, errors, isSubmitting }) => (
							<Form className="flex flex-col">
								<File
									name="arquivo"
									label="Anexe aqui a planilha (formato XLSX)"
									onSuccess={fileId => setFieldValue('arquivo', fileId)}
									format="square"
									error={errors.arquivo}
									style={{ width: 'calc(100% - 16px)' }}
									previewSize={['300px', '140px']}
									acceptedExtensions={['.xlsx']}
									className="self-center"
								/>

								<Button type="submit" className="white self-end" loading={isSubmitting}>
									Carregar arquivo
									<FiUpload size={16} />
								</Button>
							</Form>
						)}
					</Formik>
				</Card>
			</Container>

			<Modal
				isOpen={!!relatorioCargaPessoas}
				handleClose={() => {
					setRelatorioCargaPessoas(null)
				}}
				title="Relatório de carga"
			>
				{relatorioCargaPessoas && (
					<div className="mx-2">
						<p className="mt-4" style={{ fontSize: 17 }}>Total de talentos cadastrados: {relatorioCargaPessoas.pessoas_criadas}</p>

						<h2 className="font-semibold mt-4 border-t border-[#fff5] pt-3" style={{ fontSize: 18 }}>Inconsistências</h2>

						<Table
							caption="CPFs inválidos"
							headers={[
								{ name: 'linha', value: 'Número da linha', style: { width: 160 } },
								{ name: 'Nome', value: 'Nome' },
								{ name: 'CPF', value: 'CPF', centered: true, style: { width: 140 } }
							]}
							data={relatorioCargaPessoas.cpf_invalido}
						/>

						<Table
							caption="Pessoas sem nome"
							headers={[
								{ name: 'linha', value: 'Número da linha', style: { width: 160 } },
								{ name: 'Nome', value: 'Nome' },
								{ name: 'CPF', value: 'CPF', centered: true, style: { width: 140 } }
							]}
							data={relatorioCargaPessoas.sem_nome}
						/>

						<Table
							caption="Grau de formação não especificado"
							headers={[
								{ name: 'linha', value: 'Número da linha', style: { width: 160 } },
								{ name: 'Nome', value: 'Nome' },
								{ name: 'CPF', value: 'CPF', centered: true, style: { width: 140 } },
								{ name: 'Grau', value: 'Grau', centered: true },
								{ name: 'Formação', value: 'Formação', centered: true }
							]}
							data={relatorioCargaPessoas.grau_incorreto}
						/>

						<Table
							caption="Formação não especificada"
							headers={[
								{ name: 'linha', value: 'Número da linha', style: { width: 160 } },
								{ name: 'Nome', value: 'Nome' },
								{ name: 'CPF', value: 'CPF', centered: true, style: { width: 140 } },
								{ name: 'Grau', value: 'Grau', centered: true },
								{ name: 'Formação', value: 'Formação', centered: true }
							]}
							data={relatorioCargaPessoas.formacao_incorreta}
						/>
					</div>
				)}
			</Modal>
		</>
	)
}
